export const ProjectDocStatusVals = {
  New: 1,
  Development: 2,
  CompletingConfirmation: 3,
  Approved: 4,
  OnCheck: 5,
  Stopped: 6,
  Affirmed: 7,
  Affirmation: 8,
  SendingToArchive: 9,
  ApprovedByArchivarius: 10,
  NotRelevant: 11,
  Implemented: 12,
  InWorking: 13,
  Finished: 14,
}

export function getProjectDocStatusBadge(statusId?: number) {
  switch (statusId) {
    case ProjectDocStatusVals.New:
      return `badge badge-secondary`;
    case ProjectDocStatusVals.Development:
      return `badge badge-info`;
    case ProjectDocStatusVals.CompletingConfirmation:
      return `badge badge-info`;
    case ProjectDocStatusVals.Approved:
      return `badge badge-success`;
    case ProjectDocStatusVals.OnCheck:
      return `badge badge-info`;
    case ProjectDocStatusVals.Stopped:
      return `badge badge-danger`;
    case ProjectDocStatusVals.Affirmed:
      return `badge badge-success`;
    case ProjectDocStatusVals.Affirmation:
      return `badge badge-info`;
    case ProjectDocStatusVals.SendingToArchive:
      return `badge badge-info`;
    case ProjectDocStatusVals.ApprovedByArchivarius:
      return `badge badge-success`;
    case ProjectDocStatusVals.NotRelevant:
      return `badge badge-secondary`;
    case ProjectDocStatusVals.Implemented:
      return `badge badge-success`;
    default: return ``;
  }
}